import React from 'react'
import PersonCombobox from '../common/PersonCombobox'

export default function TreeControlPanel({ rootName, stats, people, onDetailChange, onRootSelect }) {
  const handleChange = (e) => {
    if (onDetailChange) onDetailChange(e.target.value)
  }

  const statsText = () => {
    if (!stats) return ''
    const parts = []
    if (stats.descendants > 0) parts.push(`${stats.descendants} descendants`)
    if (stats.ancestors > 0) parts.push(`${stats.ancestors} ancestors`)
    if (stats.blood > 0) parts.push(`${stats.blood} blood relatives`)
    if (stats.others > 0) parts.push(`${stats.others} others`)
    return `Showing ${parts.join(', ')} (total ${stats.total}).`
  }

  return (
    <div className="glass-panel border-b p-4 space-y-3 shadow-md">
      <div className="flex flex-wrap items-center gap-4 text-sm">
        <span className="text-gray-800 dark:text-gray-200">
          Kutumb of <b className="text-blue-600 dark:text-blue-400">{rootName || '...'}</b>
        </span>
        <span className="flex items-center gap-2">
          <span className="text-gray-700 dark:text-gray-300">and</span>
          <select
            className="glass-select text-sm"
            onChange={handleChange}
            defaultValue="Infinity"
          >
            <option value="0">descendants, ancestors</option>
            <option value="1">descendants, ancestors + their children, siblings</option>
            <option value="2">descendants, ancestors + their grandchildren, cousins</option>
            <option value="3">descendants, ancestors + their great-grandchildren, 2nd cousins</option>
            <option value="Infinity">descendants, ancestors + all descendants of ancestors</option>
            <option value="Everyone">everyone</option>
          </select>
        </span>
        {stats && <span className="text-gray-600 dark:text-gray-400 font-medium">{statsText()}</span>}
      </div>
      
      {people && people.length > 0 && onRootSelect && (
        <div className="flex items-center gap-3">
          <label className="text-sm text-gray-700 dark:text-gray-300 font-medium">
            Set tree root:
          </label>
          <div className="w-64">
            <PersonCombobox
              people={people}
              value={null}
              onChange={onRootSelect}
              placeholder="Select a person..."
            />
          </div>
        </div>
      )}
    </div>
  )
}
